const apiVersion = 'v1';

const getPortfolioSites = async () => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/viewsupport/portfolio/sitedata`
    );
    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getPortfolioSiteById = async (siteId) => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/viewsupport/portfolio/sitedetail/${siteId}`
    );
    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  getPortfolioSites,
  getPortfolioSiteById,
};
